import styled from "styled-components";

const StyledFilterOption = styled.div`
    width: 100%;
    height: 22px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    .option-text {
        margin: 0px;
        color: #A6A6A6 !important;      
    }

    .outer-radio-button {
        width: 18px;
        height: 18px;
        border-radius: 100px;
        border-width: 1px;
        border-style: solid;
        border-color:${({isSelected})=> isSelected ? '#38EF7D' : '#A6A6A6'};
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .inner-radio-button {
        width: 14px;
        height: 14px;
        background: ${({isSelected})=> isSelected ? '#38EF7D' : 'transparent'};
        border-radius: 100px;
    }
`;

export default function FilterOption({onSelect, isSelected, optionText}){
    return (
        <StyledFilterOption isSelected={isSelected} onClick={onSelect}>
            <p className="option-text">{optionText}</p>
            <div className="outer-radio-button">
                <div className="inner-radio-button"></div>
            </div>
        </StyledFilterOption>
    );
}